module.exports = __webpack_public_path__ + "img/page3.40d5d97b.png";